import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import { MENU_ENUM } from 'app/main/role/constants';

const CheckDrugDescriptionConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Check Drug Description',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.DRUG,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/drug/check-description',
      component: React.lazy(() => import('./CheckDrugDescription')),
    },
  ],
};

export default CheckDrugDescriptionConfig;